var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bulk-create-accounts',{attrs:{"is-loading":_vm.isLoading,"project-name-by-id":_vm.projectNameById,"created-accounts":_vm.createdAccounts},on:{"create":_vm.onCreate,"retry":_vm.onRetry}})
}
var staticRenderFns = []

export { render, staticRenderFns }